import { Component, ViewEncapsulation, Renderer2, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { GlobalsService } from '../../shared/services/globals.service';
import { Subscription } from 'rxjs';
import { ColumnComponent } from '@progress/kendo-angular-grid';
import { CommonFunctions } from '../../shared/static/common-functions';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { ScheduleDispatchBus } from '@app/cp/shared/models/ScheduleDispatchBus';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { GItem } from '@app/cp/shared/models/GItem';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { IFeatureFlagSet, UseFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
    selector: 'schedule-dispatches',
    templateUrl: './schedule-dispatches.component.html',
    styleUrls: [],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ScheduleDispatchesComponent extends BaseGridEditLineComponent<ScheduleDispatchBus, null, DispatchesService>  {
    compFeatureFlagSet: IFeatureFlagSet = this as any;

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, featureFlagService: FeatureFlagService) {
    super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.disableCpSearchDialog();
        this.className = "ScheduleDispatchBus";
        this.saveMode = SaveMode.all;
        this.appCode = "Scheduled-Dispatches";
        this.appName = "Scheduled Dispatches";
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'scheduleDispatchId': new UntypedFormControl(),
            'companyId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'unschedule': new UntypedFormControl(),
            'scheduleName': new UntypedFormControl(),
            'startDate': new UntypedFormControl(),
            'scheduleFrequencyId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'customerName': new UntypedFormControl(),
            'locationName': new UntypedFormControl(),
            'dispatchNumber': new UntypedFormControl(),
            'everyXMonths': new UntypedFormControl(),
            'isUpdated': new UntypedFormControl(),
            'isAdded': new UntypedFormControl()
        });

    }
    setForm() {
        this.editForm.patchValue({
            scheduleDispatchId: this.selectedData.scheduleDispatchId,
            companyId: this.selectedData.companyId,
            dispatchId: this.selectedData.dispatchId,
            unschedule: this.selectedData.unschedule,
            scheduleName: this.selectedData.scheduleName,
            startDate: this.selectedData.startDate,
            scheduleFrequencyId: this.selectedData.scheduleFrequencyId,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            customerName: this.selectedData.customerName,
            locationName: this.selectedData.locationName,
            dispatchNumber: this.selectedData.dispatchNumber,
            everyXMonths: this.selectedData.everyXMonths,
            isUpdated: this.selectedData.isUpdated,
            isAdded: this.selectedData.isAdded
        });
    }
    customCellClick(col: ColumnComponent) {
            if (col.field === 'dispatchNumber') {
                this.DispatchSearch = true;
            }
    }
    public addHandler(): void {
        super.addHandler();
        this.doDispatchSearch();
    }

    DispatchSearch: boolean = false;
    doDispatchSearch() {
        this.ctrlOpenFlag = true;
        this.DispatchSearch = true;
    }
    DispatchSelected(value: any) {
        this.DispatchSearch = false;
        if (value != null) {
            this.editForm.patchValue({
                dispatchNumber: value.DispatchNumber,
                dispatchId: value.DispatchId,
                customerName: value.CustomerName,
                locationName: value.LocationName
            });
            this.closeCtrlOpenFlag = true;
        }
    }
    subs_dataScheduledDispatches: Subscription;
    public setup(data: string) {
        this.clear();
        CommonFunctions.unsubscribe(this.subs_dataScheduledDispatches);
        this.subs_dataScheduledDispatches = this.svc_data.getScheduledDispatches().subscribe((data: ScheduleDispatchBus[]) => {
            if (data != null && data.length > 0) {
                this.gridData = this.getGridData(data);
                this.cloneData();
            }
            else {
                this.gridData = null;
            }
        });
    }
    test() {
        let rr = this.referenceData.getScheduleFrequencyName("253498d7-c704-45b0-9ad2-4bcedaf6fdba");
        //for (let i = 0; i < this.gridData.length; i++) {
        //    let frequency = this.referenceData.getScheduleFrequencyName(this.gridData[i].scheduleFrequencyId);
        //}
    }
    cancelEvent() {
        this.cancelHandler();
        this.gridData = null;
        this.close(false);

    }
    saveEvent() {
        let dataObjs: ScheduleDispatchBus[] = this.getChanged();
        let deletedObjs: GItem[] = this.getDeletedItems();
        for (let i = 0; i < deletedObjs.length; i++) {
            let dataObj = this.originalData.find(s => s.CID() === deletedObjs[i].value);
            dataObj.unschedule = true;
            dataObj.isUpdated = true;
            dataObjs.push(dataObj);
        }

        this.svc_data.saveScheduledDispatches(dataObjs).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {

                this.saveSuccess(null);
                this.close(true);
            }
            else {
                this.saveError(null, info.message);
            }
        });
    }
    dataChanged: boolean = false;
    sendParentMessage(type: MessageType, subject: string = null, message: string = null, values: any = null, value: any = null) {
        if (type === MessageType.changed) {
            this.dataChanged = true;
        }
        super.sendParentMessage(type, subject, message, values, value)
    }
    close(e: any) {
        this.dataChanged = false;
        super.close(e);
    }

}
